module.exports = __webpack_public_path__ + "static/media/addgreen.b60d554a.svg";